import { URLS } from 'layouts/DrawerLayout/constants';

const { request } = require('@utils');

const getExportDataJobs = async ({ urlParams, payload }) => {
  if (payload !== undefined) {
    urlParams.body = payload;
  }

  const queryParams = new URLSearchParams(urlParams).toString();

  const results = await request.get(`/v1${URLS.jobs}?${queryParams}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

export { getExportDataJobs };
